import Swiper from 'swiper';
import { Pagination, A11y } from 'swiper/modules';

const $ = window.jQuery;

const $DOM = {};
// let boxLinksSwipers = [];
let desktop = window.matchMedia('(min-width: 1024px)');

const domCache = () => {
    $DOM.containers = $(".links-box-slider.mobile-slider-layout");
    if (!$DOM.containers.length) {
        return;
    }
    $DOM.containers.each(function() {
        const $container = $(this);
        // console.log($(this));
        // const $swiperContainer = $container.find(".links-box-slider-swiper-container");
        $container.data('swiperInitialized', false);
        $container.data('swiperInstance', null);
    });
};

const initSwipers = () => {
    $DOM.containers.each(function() {
        const $container = $(this);
        const $swiperContainer = $container.find(".links-box-slider-swiper-container");

        let isDesktop = desktop.matches;
        let initialized = $container.data('swiperInitialized');

        if (isDesktop && initialized) {
            $container.data('swiperInstance').destroy();
            $container.data('swiperInitialized', false);
        } else if (!isDesktop && !initialized) {
            const swiperInstance = new Swiper($swiperContainer[0], {
                modules: [Pagination, A11y],
                // init: false,
                slidesPerView: 1.1,
                speed: 300,
                spaceBetween: 18,
                preventClicksPropagation: false,
                roundLengths: true,
                loop: false,
                watchOverflow: true,
                a11y: true,
                pagination: {
                    el: '.swiper-pagination-links',
                    clickable: true
                },
                breakpoints: {
                    768: {
                        slidesPerView: 2.1,
                        spaceBetween: 32,
                    }
                }
            });

            // swiperInstance.on("init", () => {
            //     $swiperContainer.addClass("is-init");
            // });
            $container.data('swiperInstance', swiperInstance);
            $container.data('swiperInitialized', true);
        }
    });
};

const linksBoxSlider = {
    init: () => {
        domCache();
        if (!$DOM.containers.length) {
            return;
        }

        initSwipers();

        window.addEventListener('resize', initSwipers);
    }
};

export default linksBoxSlider;